import { render, staticRenderFns } from "./GenerationHistoryFavoritesListView.vue?vue&type=template&id=4b97d70d"
import script from "./GenerationHistoryFavoritesListView.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryFavoritesListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports